<template>
  <div class="storeManage-list">
    <GlobalInfoBar
        title="议价申请"
        content="对小程序用户发起回收议价的处理列表"
    />
    <GlobalChunkNo
        icon="search"
        title="筛选查询"
    >
      
      <div slot="filter">
        <storeManageFrom />
      </div>

      <storeManageTable />
    </GlobalChunkNo>
  </div>
</template>

<script>
import storeManageFrom from './From'
import storeManageTable from './Table'
export default {
  name: 'storeManage-list',
  components: {storeManageFrom,storeManageTable},
  data(){
    return{
      userName:"",
      userPhone:"",
      roleId:"",
    }
  },
  methods:{
    
  }
}
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.merchant-list{
}
</style>
